import { useMutation } from "@tanstack/react-query";
import { api } from "./api.service";

export const useReadNotification = () => {
  return useMutation({
    mutationFn: (id: string) => {
      return api.patch("/profile/notifications/read/" + id);
    },
  });
};

export const useReadAllNotification = () => {
  return useMutation({
    mutationFn: () => {
      return api.patch("/profile/notifications/read-all");
    },
  });
};
